module.exports = __webpack_public_path__ + "img/titleAdvantage.14c96f8b.png";